import React from 'react';
import {
  Box,
  Flex,
  H1,
  H2,
  H3,
  Link,
  P,
  Typography,
  UL,
  colors,
  spacing,
  useI18nContext,
} from '@procore/core-react';
import { Plus } from '@procore/core-icons/dist';
import styled from 'styled-components';
import { OrangeLink } from '@/react/styles';
import PT from 'prop-types';

const StyledLI = styled.li`
  margin: 10px 0 10px -45px;
`;

const StyledH3 = styled(H3)`
  margin: 30px 0;
`;

const StyledPlus = styled(Plus)`
  color: ${colors.orange50};
  margin-bottom: -0.5em;
  margin-right: 5px;
`;

const NoResultsWrapper = styled(Flex)`
  flex-direction: row;
  align-items: flex-start;
  gap: ${spacing.xl}px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const NoResults = ({ isProfessionalMarketplace }) => {
  const i18n = useI18nContext();

  if (isProfessionalMarketplace) {
    return (
      <NoResultsWrapper>
        <img
          src={window.imagePath('icons/Insights.svg')}
          alt="No Search Results"
        />
        <Flex direction="column" gap="sm">
          <Box marginBottom="xxl">
            <H1 style={{ marginBottom: `${spacing.md}px` }}>
              {i18n.t('noResults.professional.title')}
            </H1>
            <Typography intent="body" className="color-concrete font-size-md">
              {i18n.t('noResults.professional.description1')}
            </Typography>{' '}
            <br />
            <Typography intent="body" className="color-concrete font-size-md">
              {i18n.t('noResults.professional.description2')}
            </Typography>
          </Box>
          <Box>
            <H2 style={{ marginBottom: `${spacing.md}px` }}>
              {i18n.t('noResults.professional.suggestionsTitle')}
            </H2>
            <UL>
              <li className="color-concrete font-size-md">
                {i18n.t('noResults.professional.browseCategories')}
              </li>
              <li className="color-concrete font-size-md">
                {i18n.t('noResults.professional.visitCommunity')}{' '}
                <Link
                  href="https://community.procore.com/s/topic/0TO2T000000c9HTWAY/integrations-app-marketplace"
                  target="_blank"
                >
                  {i18n.t('noResults.professional.communityLink')}
                </Link>{' '}
                {i18n.t('noResults.professional.communityDescription')}
              </li>
            </UL>
          </Box>
        </Flex>
      </NoResultsWrapper>
    );
  }

  return (
    <>
      <StyledH3>{i18n.t('noResults.standard.title')}</StyledH3>
      <P>{i18n.t('noResults.standard.description')}</P>

      <StyledH3>{i18n.t('noResults.standard.suggestionsTitle')}</StyledH3>

      <Typography as="ul" style={{ listStyleType: 'none' }}>
        <StyledLI>
          <StyledPlus />
          {i18n.t('noResults.standard.browseCategories')}
        </StyledLI>
        <StyledLI>
          <StyledPlus />
          {i18n.t('noResults.standard.visitCommunity')}&nbsp;
          <OrangeLink
            href="https://community.procore.com/s/topic/0TO2T000000c9HTWAY/integrations-app-marketplace"
            target="_blank"
          >
            {i18n.t('noResults.standard.communityLink')}
          </OrangeLink>{' '}
          {i18n.t('noResults.standard.communityDescription')}
        </StyledLI>
        {!window.IS_FEDRAMP && (
          <StyledLI>
            <StyledPlus />
            <OrangeLink
              href="https://marketplace.procore.com/#submit-idea"
              target="_blank"
            >
              {i18n.t('noResults.standard.makeSuggestion')}
            </OrangeLink>{' '}
            {i18n.t('noResults.standard.suggestionDescription')}
          </StyledLI>
        )}
      </Typography>
    </>
  );
};

NoResults.propTypes = {
  isProfessionalMarketplace: PT.bool,
};

export default NoResults;
